import type { ExtraFieldName } from '@shared/model'
import type { AppInputType } from '@shared/ui/inputs'
import type { ExtraFieldModel } from '../../extra-field-model.hook'

import { useListsStore } from '@shared/model'

import { useExtraFieldModel } from '../../extra-field-model.hook'

interface InputProductDislikeLinkReturn {
  name: ExtraFieldName
  placeholder: string
  model: ExtraFieldModel
  inputType: AppInputType
  isRequired: ComputedRef<boolean>
}

export const useInputProductDislikeLink = (): InputProductDislikeLinkReturn => {
  const listsStore = useListsStore()
  const name: ExtraFieldName = 'product_dislike_link'
  const placeholder = 'Type here'
  const inputType: AppInputType = 'text'

  const model = useExtraFieldModel(name)

  const isRequired = computed(() => listsStore.getTasksKanbanConfig?.extra_fields[name]?.required || false)

  return {
    name,
    placeholder,
    inputType,
    model,
    isRequired,
  }
}
